import authHeaders from "@/lib/authHeaders";
import FiltersData from "@/models/production/queue-list/FiltersData";

const loadFilterOptions = async (): Promise<FiltersData> => {
  return fetch(
    `${import.meta.env.VITE_VTS_API}/v1/production/queue_list/filter_options`,
    {
      headers: authHeaders(),
    },
  ).then((response) => {
    if (response.status === 200) {
      return response.json();
    } else {
      throw new Error(`Error ${response.status}. Failed to load the filters.`);
    }
  });
};

export default loadFilterOptions;
